import { StsCaptchaType } from 'app/models/sts-captcha-type.model';
import { StsTextCaptchaComponent } from './sts-text-captcha/sts-text-captcha.component';
import { StsRecaptchaComponent } from './sts-recaptcha/sts-recaptcha.component';
import { StsCaptcha } from 'app/models/sts-captcha.model';
import { StsTenantService } from 'app/services/sts-tenant.service';

import {
  Component,
  EventEmitter,
  Output,
  ViewChild,
  AfterViewInit
} from '@angular/core';
import { Variable } from '@angular/compiler/src/render3/r3_ast';


@Component({
  selector: 'app-sts-captcha',
  templateUrl: './sts-captcha.component.html',
  styleUrls: ['./sts-captcha.component.scss']
})
export class StsCaptchaComponent implements AfterViewInit {
  @Output() onValidate: EventEmitter<any> = new EventEmitter();
  @ViewChild(StsTextCaptchaComponent) textCaptcha: StsTextCaptchaComponent;
  @ViewChild(StsRecaptchaComponent) recaptcha: StsRecaptchaComponent;

  stsCaptchaType = StsCaptchaType;
  captchaType: StsCaptchaType;
  interval:any;

  constructor(private tenantService: StsTenantService) {}

  ngAfterViewInit() {
    this.tenantService.getTenantSource().subscribe(tenant => {
      this.captchaType = tenant.captchaType;
    });
    this.interval= setInterval(() => {
     this.fixAccessibility();
    }, 20);
  }

  public submit() {
    this.getComponent().submit();
  }

  fixAccessibility() {
    var textareas = document.getElementsByClassName('g-recaptcha-response');
    if (textareas && textareas.length > 0) {
      for (var ind = 0; ind < textareas.length; ind++) {
        if (!textareas[ind].hasAttribute('title')) {
          textareas[ind].setAttribute("title", "Select captcha");
          var span = document.createElement("label");
          span.setAttribute('class', 'visuallyhidden');
          span.setAttribute('for', 'g-recaptcha-response');
          var text = document.createTextNode("select captcha");
          span.appendChild(text);
          textareas[ind].parentNode.insertBefore(span, textareas[ind].nextSibling);
          clearInterval(this.interval);
        }
      }
    }
  }

  public checkForCaptchaError(captchaObj: StsCaptcha) {
    return this.getComponent().checkForCaptchaError(captchaObj);
  }

  public reset() {
    this.getComponent().reset();
  }

  onSubmit(captchaObj: StsCaptcha) {
    this.onValidate.emit(captchaObj);
  }

  private getComponent() {
    if (this.captchaType === StsCaptchaType.text) {
      return this.textCaptcha;
    } else {
      return this.recaptcha;
    }
  }
}
